import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {

  transform(value: Array<string>, glue: string): any {
    return value.join(glue);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/join.pipe.ts